export default __webpack_public_path__ + "1de3c0e.png";